import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../../redux/store";
import FormularioRemitente from "./FormularioRemitente/FormularioRemitente";
import FormularioDestinatario from "./FormularioDestinario/FormularioDestinatario";
import CanalModerno from "./CanalModerno/CanalModerno";
import CanalClasico from "./CanalClásico/CanalClasico";
import NumeroGuia from "./NumeroGuia/NumeroGuia";
import { logistica_GUIA_PROFORMAviewModel } from "../../../ViewModels/logistica_GUIA_PROFORMAviewModel";
import { saveGuiaPrevisualizar } from "../../../redux/actions/actionsCrear";
import { logistica_GUIA_PROFORMALocal } from "../../Entidades/logistica_GUIA_PROFORMA";
import ResultadoDetalles from "./ResultadoDetalles.tsx/ResultadoDetalles";
import Observacion from "./Observacion/ObservacionGuia";
import CiudadesYModoEntrega from "./Ciudades_ModoEntrega/Ciudades_ModoEntrega";
import Seguro_Documentos from "./Seguro_Documentos/Seguro_Documentos";
import Footer from "../../../Footer/Footer";

interface ChildsProps {
  vm: logistica_GUIA_PROFORMAviewModel
}
const CrearGuia: React.FC<ChildsProps> = ({vm}) => {
  const [guia, setGuia] = useState(new logistica_GUIA_PROFORMALocal())
  const [errorMsg, setErrorMsg] = useState("")
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const infoGuiaStore = useSelector((state: RootState) => state.crear.guiaPrevisualizar);
  const rangoGuiaStore = useSelector((state: RootState) => state.crear.rangoGuia)

  useEffect(() => {
    if (infoGuiaStore.info) {
      vm.cargarDatos(infoGuiaStore.info, setGuia) 
    }
  }, [infoGuiaStore])


  const handlePrevisualizar = () => {
    try {
      vm.Validar(guia)
      setErrorMsg("")
      dispatch(saveGuiaPrevisualizar(guia))
      navigate("/home/previsualizar")
    } catch (error) {
      if(error instanceof Error){
        setErrorMsg(error.message)
      }
    }    
  }

  return (
    <div id="content" className="main-content">
      <div className="layout-px-spacing">
        <div className="">
          <div className="">
            <div className="doc-container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="invoice-content">
                    <div className="invoice-detail-body mb-2">
                      <div className="invoice-detail-title">
                        <div className="invoice-00001">
                          <div className="col-sm-12 text-center">
                            <div className="inv-list-number">
                              <span className="inv-title">
                                <NumeroGuia vm={vm} guia={guia} setGuia={setGuia} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {rangoGuiaStore.errorUndefined?
                      <></>
                      :<>
                        <div className="invoice-detail-header">
                          <div className="row justify-content-between">
                            <FormularioRemitente vm={vm} guia={guia} setGuia={setGuia}/>
                            <FormularioDestinatario vm={vm} guia={guia} setGuia={setGuia}/>
                          </div>
                          <hr style={{borderTop: "1px solid rgba(0,0,0,.1)"}}/>
                          <div className="row justify-content-between">
                            <CiudadesYModoEntrega vm={vm} guia={guia} setGuia={setGuia}/>
                            <Seguro_Documentos vm={vm} guia={guia} setGuia={setGuia}/>
                          </div>
                          <CanalModerno />
                          <CanalClasico vm={vm} guia={guia} setGuia={setGuia}/>
                        </div>
                        <ResultadoDetalles  vm={vm} guia={guia} setGuia={setGuia} />
                        <Observacion  vm={vm} guia={guia} setGuia={setGuia} />
                        <p className="text-danger" style={{ marginTop: ".5rem", marginBottom: ".5rem" }}>{errorMsg}</p>
                        <div className="invoice-action-btn">
                          <div className="row">
                            <div className="cold-md-12 col-sm-12 text-center mb-2 mt-4">
                              <button className="btn btn-danger mr-4" onClick={() => vm.estadoInicial(setGuia)}>Limpiar Guia</button>
                              <button className="btn btn-primary btn-send ml-4" onClick={() => handlePrevisualizar()}>Previsualizar</button>
                            </div>
                          </div>
                        </div>
                      </>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default CrearGuia;


export interface ChildProps_logistica_GUIA_PROFORMAviewModel {
  vm: logistica_GUIA_PROFORMAviewModel;
  guia: logistica_GUIA_PROFORMALocal
  setGuia: (details: logistica_GUIA_PROFORMALocal) => void
}